import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
export const SearchIcon = MagnifyingGlassIcon;
